import { useNavigate } from 'react-router-dom';
import { Anchor, Breadcrumbs, Container, Divider, Group, Tabs } from '@mantine/core';
import { useContext } from 'react';
import { DndProvider } from 'react-dnd-latest';
import { HTML5Backend } from 'react-dnd-html5-backend-latest';
import { IconCar, IconFileInvoice, IconHash } from '@tabler/icons';
import { DocumentTemplateContext } from '../../../Service/Context/DocumentTemplateContext';
import BookitupAlert from '../../../Atoms/BookitupAlert';
import DocumentLanguagePicker from '../../../Atoms/inputs/DocumentLanguagePicker';
import DocumentTemplateActions from './DocumentTemplateActions';
import DocumentTemplateSkeleton from './DocumentTemplateSkeletonV2';
import DistancePolicySettings from './DistancePolicySettings';

const DocumentTemplateEditor = () => {
  const navigate = useNavigate();
  const { loading, bookitupDocument, savePatch } = useContext(DocumentTemplateContext);
  const { name, documentType, language } = bookitupDocument ?? {};

  return (
    <Container p={0}>
      <Group position="apart">
        <Breadcrumbs>
          <Anchor onClick={() => navigate('/settings/templates')}>Vorlagen</Anchor>
          <Anchor sx={{ pointerEvents: 'none' }}>
            <b>{loading ? 'Laden ...' : name || 'Nicht gefunden '}</b>
          </Anchor>
        </Breadcrumbs>
        <Group>
          <DocumentLanguagePicker
            language={language}
            onLanguageChange={bookitupDocument ? (newLanguage) => savePatch({ language: newLanguage }) : undefined}
          />
          <DocumentTemplateActions />
        </Group>
      </Group>
      <Divider my="sm" />
      <BookitupAlert mb="md" title="Tipp: Platzhalter" icon={<IconHash />}>
        Du kannst Platzhalter einfügen, indem du die Raute-Taste (#) drückst.
      </BookitupAlert>

      <Tabs defaultValue="content">
        <Tabs.List>
          <Tabs.Tab value="content" icon={<IconFileInvoice size={14} />}>
            Inhalt
          </Tabs.Tab>
          {documentType !== 'REMINDER' && (
            <Tabs.Tab value="distance" icon={<IconCar size={14} />}>
              Frei-Kilometer
            </Tabs.Tab>
          )}
        </Tabs.List>
        <Tabs.Panel value="content" pt="xl">
          <DndProvider backend={HTML5Backend}>
            <DocumentTemplateSkeleton />
          </DndProvider>
        </Tabs.Panel>
        {documentType !== 'REMINDER' && (
          <Tabs.Panel value="distance" pt="xl">
            <DistancePolicySettings />
          </Tabs.Panel>
        )}
      </Tabs>
    </Container>
  );
};

export default DocumentTemplateEditor;
